import { render, staticRenderFns } from "./SubAccounts.vue?vue&type=template&id=0edcbdd3&"
import script from "./SubAccounts.vue?vue&type=script&lang=js&"
export * from "./SubAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports